/**
 * HeroSection Component
 * 
 * Reusable hero section that appears at the top of wedding pages.
 * Handles both desktop and mobile layouts with consistent branding.
 * 
 * Props:
 * - subtitle: Custom subtitle text (default: "warmly welcome you to their Wedding")
 * - date: Date text to display (default: "22nd, 24th & 25th Nov 2025")
 * - variant: Style variant for different page types
 */

import React from 'react';

const HeroSection = ({ 
  subtitle = "warmly welcome you to their Wedding", 
  date = "22nd, 24th & 25th Nov 2025",
  variant = "default"
}) => {
  return (
    <>
      {/* Desktop Hero Section */}
      <div className="hero">
        <div className="hero-text">
          <img src={`${process.env.PUBLIC_URL}/logo2.png`} alt="Wedding Logo" className="hero-logo" />
          <h1>Radhika & Vivek</h1>
          <p>{subtitle}</p>
          <p>{date}</p>
        </div>
      </div>

      {/* Mobile Hero Section */}
      <div className="hero-text-section">
        <div className="hero-text-content">
          <img src={`${process.env.PUBLIC_URL}/logo2.png`} alt="Wedding Logo" className="hero-logo" />
          <h1>Radhika & Vivek</h1>
          <p>{subtitle}</p>
          <p>{date}</p>
        </div>
      </div>
    </>
  );
};

export default HeroSection;